import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@app/context/ModalsContext'

import { AuthSessionContext } from '@context/AuthContext'

import { getDateTimeFormat } from '@ui/v2/Table/cells/DateTime'
import { useTableColumns } from '@ui/v2/Table/hooks/useTableRows'
import { TableViewMoreModal } from '@ui/v2/Table/modals/TableViewMore.modal'

import { AccountSummaryDto } from '@model/AccountSummaryDto'

import { useFormatNumber } from '@hooks/useFormatNumber'

import { IAppendableFetchQueryResult, SearchResponseProps } from '../IBReportResultsPage'
import { IBReportsTable } from '../IBReportsTable'
import { ClientColumn, ClientColumnCtx, clientColumns } from './IBClientsTable.columns'

export type IBClientsTableSortKeys =
  | 'Login'
  | 'ClientName'
  | 'AccountType'
  | 'RegistrationDate'
  | 'FxmVolume'
  | 'OtherVolume'
  | 'FxmAmount'
  | 'OtherAmount'
  | 'SpreadRevenue'
  | 'Currency'
  | 'Country'
  | 'TickmillCompany'

interface IBClientsTableProps {
  data: IAppendableFetchQueryResult<AccountSummaryDto>
  search: SearchResponseProps
}

export const IBClientsTable: React.FC<IBClientsTableProps> = (props) => {
  const { data: ibAccountSummary, search } = props

  const [auth] = useContext(AuthSessionContext)
  const rawDateFormat = auth?.dateFormatType?.name
  const dateFormat = getDateTimeFormat(rawDateFormat)

  const { formatNumber, formatMoney } = useFormatNumber()
  const { t } = useTranslation()

  const colsFormatCtx: ClientColumnCtx = { t, formatNumber, formatMoney, dateFormat }
  const clientsViewMoreModal = useModal(TableViewMoreModal<AccountSummaryDto>)
  const data = ibAccountSummary.query.data ?? []
  const { renderColumns } = useTableColumns<AccountSummaryDto, ClientColumnCtx, ClientColumn>({
    columns: clientColumns,
    formatCtx: colsFormatCtx,
    onArrowClick: (_, index) =>
      clientsViewMoreModal.open({
        data,
        initialIndex: index,
        formatCtx: colsFormatCtx,
        columns: clientColumns,
      }),
  })

  return (
    <IBReportsTable
      tableQuery={ibAccountSummary.query}
      sortOptions={search.sortOptions}
      renderColumns={renderColumns}
    />
  )
}
